import {
    CategoryScale,
    Chart as ChartJS, Filler, Legend,
    LinearScale,
    LineElement,
    PointElement,
    Title, Tooltip
} from "chart.js";
import {useEffect, useMemo, useState} from "react";
import { Line } from 'react-chartjs-2';
import {CHART_COLORS} from "../consts/COLOR_SETS.js";
import "../style.css";
import {BaseChart} from "./BaseChart";

export const LineChart = ({ data, dataSets, labels, title = "", isDataLoaded = false }) => {
    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Legend,
        Filler
    );

    const digestedData = useMemo(() => {
        if(data?.length) {
            return {
                labels,
                datasets: dataSets.map((dataSet, index) => {
                    return {
                        label: dataSet.label,
                        data: dataSet.values,
                        borderColor: dataSet.borderColor ? dataSet.borderColor : dataSet.isGreyed ? 'rgba(222, 222, 222, 0.5)' : CHART_COLORS[index]?.solid,
                        backgroundColor: dataSet.backgroundColor ? dataSet.backgroundColor : dataSet.isGreyed ? 'rgba(222, 222, 222, 0.5)' : CHART_COLORS[index]?.transparent,
                        fill: true,
                    };
                })
            };
        } else {
            return {
                labels: [],
                datasets: [],
            };
        }
    }, [data]);

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    font: {
                        family: 'quicksand-bold'
                    },
                    boxWidth: 12,
                },
            },
        },
        tension: 0.1,
        scales: {
            y: {
                ticks: {
                    precision: 0,
                    font: {
                        family: 'quicksand-bold'
                    }
                },
            },
            x: {
                ticks: {
                    font: {
                        family: 'quicksand-bold'
                    }
                },
            }
        },
        elements: {
            point: {
                radius: 2,
                hoverRadius: 5, // ex.: to make it bigger when user hovers put larger number than radius.
            }
        }
    };

    return <BaseChart
        data={digestedData}
        options={options}
        title={title}
        Chart={Line}
        isDataLoaded={isDataLoaded}
    />;
}